import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-terminos',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './terminos.html',
  styleUrl: './terminos.scss'
})
export class TerminosComponent {
  siteConfig = environment.siteConfig;

  constructor(private dialogRef: MatDialogRef<TerminosComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
